import { render, staticRenderFns } from "./mobile-controls.vue?vue&type=template&id=d6318732&"
import script from "./mobile-controls.vue?vue&type=script&lang=js&"
export * from "./mobile-controls.vue?vue&type=script&lang=js&"
import style0 from "./mobile-controls.vue?vue&type=style&index=0&land=less&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports